module.exports = __webpack_public_path__ + "img/ic_sand.2bd8abf6.png";